import React from 'react';
import { Box } from '@mui/material';
import SectionCard from '../SectionCard';
import FilterToolbar from '../FilterToolbar';
import { IPD_COLORS } from '../../theme';

/**
 * Unified list page shell — filters and data grid in one card for a cohesive admin layout.
 */
export default function MasterListShell({ title, subtitle, filters, children, sx = {} }) {
  return (
    <SectionCard
      title={title}
      subtitle={subtitle}
      noPadding
      sx={{
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
        ...sx,
      }}
    >
      {filters && (
        <Box
          sx={{
            px: 2.5,
            py: 2,
            borderBottom: `1px solid ${IPD_COLORS.border}`,
            backgroundColor: IPD_COLORS.panelHeaderBg,
          }}
        >
          <FilterToolbar variant="embedded">
            {filters}
          </FilterToolbar>
        </Box>
      )}
      <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
        {children}
      </Box>
    </SectionCard>
  );
}
